<template>
  <HeadImage
    :heading=heading
    :bg_image=bg_image
    :title1=head_title1
    :title2=head_title2
    :subtitle=head_subtitle
  />
  <div class="mt-4">
    <MDBCard v-if="is_card">
      <MDBCardHeader>
        <h1 class="text-center">{{page_title}}</h1>
      </MDBCardHeader>
      <MDBCardBody>
        <slot></slot>
      </MDBCardBody>
    </MDBCard>
    <div class="bg-light" v-else>
      <div class="bg-primary text-light py-2">
        <h1 class="text-center container">{{page_title}}</h1>
      </div>
      <div class="container">
        <div class="row bg-grey" >
          <div :class="(sidebar!==undefined)?'col-12 col-lg-8 col-xl-9':'col-12'">
            <slot></slot>
          </div>
          <div v-if="sidebar=='entruempelung'" class="col-12 col-lg-4 col-xl-3">
            <div class="affix sticky-top" >
              <ContactButtonsEntruempelungSidebar/>
            </div>
          </div>
          <div v-else-if="sidebar=='umzug'" class="col-12 col-lg-4 col-xl-3">
            <div class="affix sticky-top" >
              <ContactButtonsEntruempelungSidebar/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-4 container">
      <ContactFormCard/>
  </div>
  <!-- Sharingbutton Facebook -->
  <div v-if="share_buttons === true" class="my-2">
    <p class="text-center mt-4"><SocialShareButtons :share_url="currentRoutePath" :share_text="shareText" /></p>
  </div>
</template>
<script>
import { MDBCard, MDBCardBody, MDBCardHeader  } from "mdb-vue-ui-kit"
import SocialShareButtons from '@/components/SocialShareButtons.vue'
import ContactFormCard from '@/components/ContactFormCard.vue'
import ContactButtonsEntruempelungSidebar from '@/components/ContactButtonsEntruempelungSidebar.vue'
import { useMeta } from 'vue-meta'
import { useRoute } from 'vue-router'
import HeadImage from '@/components/HeadImage.vue'

export default {
  name: 'Article',
  props: {
    heading: {
      type: Boolean,
      default: false
    },
    sidebar: {
      type: String,
      default: undefined
    },
    is_card: {
      type: Boolean,
      default: false
    },
    page_title: {
      type: String,
      required: true
    },
    head_title1: {
      type: String,
      default: undefined
    },
    head_title2: {
      type: String,
      default: undefined
    },
    head_subtitle: {
      type: String,
      default: undefined
    },
    meta_title: {
      type: String,
      required: true
    },
    keywords: {
      type: Array,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    bg_image: {
      type: String,
      default: require('@/assets/slide1_light.webp')
    },
    share_url: String,
    share_text: String,
    share_buttons: Boolean
  },
  components: {
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    SocialShareButtons,
    ContactFormCard,
    ContactButtonsEntruempelungSidebar,
    HeadImage
  },
  data() {
    return {

    };
  },
  methods: {
    onSubmit() {

    }
  },
  computed: {
      currentRoutePath() {
        if(this.share_url !== null && this.share_url !== undefined) {
          return this.share_url
        } else {
          return process.env.VUE_APP_URL + this.$route.fullPath
        }
      },
      shareText() {
        var retvalue = ''
        if(this.share_text !== null && this.share_text !== undefined) {
          retvalue = this.share_text
        } else if ( this.page_title !== null && this.page_title !== undefined) {
          retvalue = this.page_title
        } else {
          retvalue = process.env.VUE_APP_NAME
        }
      return retvalue
    }
  },
  setup(props) {
    var keywordstext = ""
    if(props.keywords != undefined && props.keywords != null && props.keywords.length > 0)
    {
      keywordstext = props.keywords.join(", ")
    }
    var title = props.meta_title + ""
    var description = "" + props.description
    var route = useRoute()
    var url = process.env.VUE_APP_URL + route.path
    useMeta({
      title: title,
      description: description,
      keywords: keywordstext,
      link: {
        rel: "canonical",
        href: url
      },
      og: {
        type: "website",
        title: title,
        url: url,
        description: description,
        site_name: process.env.VUE_APP_NAME
      },
      twitter: {
        card: "summary",
        title: title,
        url: url,
        description: description,
        label1: "Geschätzte Lesezeit",
        data1: "5 Minuten"
      },
      robots: "index, follow"
    })
  }

}
</script>
